import Config from '../config/apiUrl';
import { storage } from '../config/storage';

export const NEXT_STEP_STATUS = {
  NONE: 'none',
  PENDING: 'pending',
  READY: 'ready',
};

const REQUEST_TIMEOUT_MS = 8000;

/**
 * Does the candidate who just finished this assessment go straight into the AI interview?
 * Calls fetch directly rather than Api.get: a poll must not report every failure to
 * Sentry or trigger the global session-expired handling on the end screen.
 * Server trouble and network errors are `pending` (the caller's time cap ends the wait);
 * any other rejection is `none`.
 * @param {string} linkId
 * @returns {Promise<{status: string, interviewUrl?: string}>}
 */
export const fetchAssessmentNextStep = async (linkId) => {
  const token = storage.get.authToken();
  if (!token || !linkId) return { status: NEXT_STEP_STATUS.NONE };

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    const res = await fetch(`${Config.API_URL}/api/session/v1/link/${linkId}/next-step`, {
      headers: { Authorization: `${token}` },
      signal: controller.signal,
    });
    if (res.status >= 500 || res.status === 429) return { status: NEXT_STEP_STATUS.PENDING };
    if (!res.ok) return { status: NEXT_STEP_STATUS.NONE };

    const body = await res.json();
    if (body?.status === NEXT_STEP_STATUS.READY && body.interviewUrl) {
      return { status: NEXT_STEP_STATUS.READY, interviewUrl: body.interviewUrl };
    }
    return {
      status: body?.status === NEXT_STEP_STATUS.PENDING
        ? NEXT_STEP_STATUS.PENDING
        : NEXT_STEP_STATUS.NONE,
    };
  } catch (error) {
    return { status: NEXT_STEP_STATUS.PENDING };
  } finally {
    clearTimeout(timeout);
  }
};
